import { render, staticRenderFns } from "./AdminBookingsAwaitingDictation.vue?vue&type=template&id=06951d4c"
import script from "./AdminBookingsAwaitingDictation.vue?vue&type=script&lang=js"
export * from "./AdminBookingsAwaitingDictation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports